import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import 'maplibre-gl/dist/maplibre-gl.css';

import { App } from './App';
import { FeatureFlagsProvider } from './contexts/featureFlagContext';
import { theme } from './theme';

declare global {
  interface Window {
    __FIELD_OPS_ENV__?: Record<string, string | undefined>;
  }
}

const root = document.getElementById('app');

if (!root) {
  throw new Error('Missing #app root element');
}

createRoot(root).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <FeatureFlagsProvider>
          <App />
        </FeatureFlagsProvider>
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
);
